"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveAnimatedImageSource = void 0;
const resolveAnimatedImageSource = (src) => {
    return new URL(src, typeof window === 'undefined' ? undefined : window.origin)
        .href;
};
exports.resolveAnimatedImageSource = resolveAnimatedImageSource;
